export const description = "Illustrateur • Bédéiste • Dev Front-End";
